import consumer from './consumer';

document.addEventListener('DOMContentLoaded', () => {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof iframe == 'object')) {
      consumer.disconnect();
      $('#subscriptionStep2').addClass('d-none');
      $('#subscriptionStep3').addClass('d-none');
      $('#subscriptionStep4').addClass('d-none');
      $('#subscriptionStep5').addClass('d-none');
      $('#subscriptionStepError').removeClass('d-none');
    }
  }

  function generateUniversignIframe(signerId) {
    const configuration = {};
    const iframeEndpoint = $('#subscriptionStep4').data('universign-iframe-endpoint');
    /**
     * The universignSigInit function add an iframe element as child of element with
     * id attribute equals to containerId parameter, the attribute src is set from
     * the universignUrl variable, it is the url of the website to be integrated in
     * the iframe, the width and height of the iframe will take 100% of its
     * container.
     *
     * @param {string} containerId The id of the element in which we will inject
     * the iframe.
     * @param {string} signerId The identifier of transaction.
     * @param {object} configuration The options list to customize the iframe:
     * * redirectionMode {string} This params have two possible values: IN or OUT,
     * the dafault value is OUT,
     * if the value of this params is equal to OUT the redirection will be done
     * outside the iframe(in website container of the iframe),
     * if the value of this params is equal to ÌN the redirection will be done
     * inside the iframe,
     * if the value of this params is otherwise, an exception will be triggered.
     **/

    universignSigInit('subscriptionStep4', signerId, configuration, iframeEndpoint);
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '86%';
    iframe.src = documentUrl;

    $('#subscriptionStep4').prepend(iframe);

    $('.edit_subscription').on('ajax:success', function (event) {
      $('#subscriptionStep4').addClass('d-none');
      $('#subscriptionStep5').removeClass('d-none');
      updateBreadcrumbStep();
    });
  }

  function updateBreadcrumbStep() {
    const currentStep = $('li[data-step-state="current"]');
    currentStep.attr('data-step-state', 'past');
    currentStep.attr('data-step-completed', 'true');

    const currentStepSpan = currentStep.find('span.nav-link');
    currentStepSpan.removeClass('text-primary-700 fw-semibold bg-primary-50 rounded-pill');
    currentStepSpan.addClass('text-gray-700');
    currentStepSpan.find('.step-check-icon').removeClass('d-none');

    const nextStep = $('li[data-step-state="future"]:first');
    nextStep.attr('data-step-state', 'current');

    const nextStepSpan = nextStep.find('span.nav-link');
    nextStepSpan.removeClass('text-gray-500 disabled');
    nextStepSpan.addClass('text-primary-700 fw-semibold bg-primary-50 rounded-pill');
  }

  function enableSddMandate(data) {
    $('#sddMandateLoadedButton').removeClass('disabled');
    $('#sddMandateLoadedButton').attr({ href: data.sdd_mandate_signature_url });

    $('#subscriptionStep2 #step-title').text($('#subscriptionStep2').data('title-in-case-of-doc-ready'));
    $('#subscriptionStep2 #step-image').attr('src', $('#subscriptionStep2').data('image-in-case-of-doc-ready'));
    $('#generatingSddMandateInProgressExplanations').addClass('d-none');
    $('#generatingSddMandateReadyExplanations').removeClass('d-none');
  }

  function enableContract() {
    // Enable the button to load the contract and display the success message
    $('#contractLoadedButton').prop('disabled', false);
    $('#subscriptionStep3 #step-title').text($('#subscriptionStep3').data('title-in-case-of-doc-ready'));
    $('#subscriptionStep3 #step-image').attr('src', $('#subscriptionStep3').data('image-in-case-of-doc-ready'));
    $('#generatingDocInProgressExplanations').addClass('d-none');
    $('#generatingDocReadyExplanations').removeClass('d-none');

    $('#contractLoadedButton').on('click', (_e) => {
      $('#subscriptionStep4').removeClass('d-none');
      $('#subscriptionStep3').addClass('d-none');
      updateBreadcrumbStep();
    });
  }

  if (!$('#signature-subscription-id').length) {
    return;
  }

  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  consumer.subscriptions.create(
    { channel: 'SignatureChannel', subscription_id: $('#signature-subscription-id').data('id') },
    {
      received(data) {
        try {
          if (data.status == 'success') {
            clearTimeout(docliftDoesNotAnswerTimer);

            if (data.reload !== undefined) {
              window.location.reload();
            }
            else if (data.sdd_mandate_signature_url !== undefined) {
              enableSddMandate(data)
            }
            else if (data.e_sign_id !== undefined) {
              generateUniversignIframe(data.e_sign_id);
            } else {
              generateContractIframe(data.document_url);
            }

            if ($('#signature-subscription-id').data('step') === 'contract_generation') { enableContract() }

          } else {
            setTimeout(() => {
              $('#subscriptionStep2').addClass('d-none');
              $('#subscriptionStep3').addClass('d-none');
              $('#subscriptionStep4').addClass('d-none');
              $('#subscriptionStep5').addClass('d-none');
              $('#subscriptionStepError').removeClass('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            $('#subscriptionStep2').addClass('d-none');
            $('#subscriptionStep3').addClass('d-none');
            $('#subscriptionStep4').addClass('d-none');
            $('#subscriptionStep5').addClass('d-none');
            $('#subscriptionStepError').removeClass('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#subscriptionStep2').addClass('d-none');
          $('#subscriptionStep3').addClass('d-none');
          $('#subscriptionStep4').addClass('d-none');
          $('#subscriptionStep5').addClass('d-none');
          $('#subscriptionStepError').removeClass('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
});
